module.exports = __webpack_public_path__ + "img/gas-pump-regular.3df84376.svg";